import React from 'react'

const Privacypolicy = () => {
    return (
        <div>
            <strong>Privacy Policy</strong>
            <ul>
                <li><strong>Effective Date:</strong>7th November 2025</li>
                <li><strong>Operated by:</strong> Fyjix IT Solutions (India)</li>
                <li>
                    This Privacy Policy explains how Fyjix collects, uses, stores, and protects personal information when you access or use our text-to-speech service (the "Service"). By using the Service, you agree to the practices described in this Policy. If you do not agree with this Policy, please discontinue use of the Service.
                </li>

                <strong>1. Information We Collect</strong>
                <ul>
                    <li>We collect only the information necessary to operate the Service, maintain security, and prevent misuse.</li>

                    <strong>1.1 Account Information</strong>
                    <ul>
                        <li>Email address (required)</li>
                        <li>Name and contact number (optional)</li>
                    </ul>

                    <strong>1.2 Usage and Log Data</strong>
                    <ul>
                        <li>IP address</li>
                        <li>Text input submitted for generating audio</li>
                        <li>User actions on the platform</li>
                        <li>Character usage logs</li>
                        <li>Character count history</li>
                    </ul>

                    <strong>1.3 Payment Information</strong>
                    <ul>
                        <li>We do not store any payment card details.</li>
                        <li>Payments are processed securely through the TJSB Bank payment gateway.</li>
                    </ul>

                    <strong>1.4 Cookies and Tracking</strong>
                    <ul>
                        <li>We do not use tracking cookies, analytics tools, or advertising pixels.</li>
                        <li>We use session cookies only for login and secure account operation.</li>
                    </ul>

                    <strong>1.5 Generated Audio</strong>
                    <ul>
                        <li>We do not store, save, archive, or retain any audio generated through the Service.</li>
                    </ul>
                </ul>

                <strong>2. How We Use Your Information</strong>
                <ul>
                    <li>Account creation and authentication</li>
                    <li>Operating and improving the Service</li>
                    <li>Monitoring usage and maintaining platform security</li>
                    <li>Detecting abuse or unauthorized activity</li>
                    <li>Processing payments and providing purchased services</li>
                    <li>Communicating essential service updates</li>
                    <li>We do not use your information for advertising or profiling.</li>
                </ul>

                <strong>3. Data Retention</strong>
                <ul>
                    <li>Text input logs, IP addresses, and user activity logs are retained for one year.</li>
                    <li>If suspicious, abusive, or illegal behaviour is detected, relevant logs may be stored indefinitely for security, investigation, or compliance reasons.</li>
                    <li>Account information is retained as long as your account is active.</li>
                    <li>When a user deletes their account, we will delete associated personal data within 30 days, except logs kept for security or legal purposes.</li>
                </ul>

                <strong>4. Security Measures</strong>
                <ul>
                    <li>Encryption of data during transmission</li>
                    <li>Secure hosting infrastructure (Render)</li>
                    <li>Access controls and restricted administrative access</li>
                    <li>Regular platform monitoring for suspicious behaviour</li>
                    <li>While we take every reasonable measure, no system is completely immune from security risks.</li>
                </ul>

                <strong>5. Sharing of Data</strong>
                <ul>
                    <li>We do not sell, rent, or trade your information.</li>
                    <li>We do not share user data with third parties except in the following cases:</li>

                    <li>
                        <strong> Payment Processing</strong>
                        <ul>
                            <li>Information necessary for payment processing is handled directly by TJSB Bank.</li>
                        </ul>
                    </li>

                    <li>
                        <strong>Legal Compliance</strong>
                        <ul>
                            <li>We may disclose information if required to:</li>
                            <li>Comply with applicable law</li>
                            <li>Respond to lawful requests</li>
                            <li>Protect the rights and safety of Fyjix or its users</li>
                        </ul>
                    </li>

                    <li>
                        <strong>Business Transfers</strong>
                        <ul>
                            <li>If Fyjix IT Solutions merges, is acquired, or undergoes restructuring, user data may be transferred to the new entity under the same privacy protections outlined here.</li>
                        </ul>
                    </li>
                </ul>

                <strong>6. User Rights</strong>
                <ul>
                    <li>
                        <strong> Account Deletion</strong>
                        <ul>
                            <li>You may delete your account at any time.</li>
                            <li>After the request, we will delete your personal data within 30 days, except logs kept for security or compliance.</li>
                        </ul>
                    </li>

                    <li>
                        <strong>Correction of Information</strong>
                        <ul>
                            <li>If your stored information is incorrect, you may request correction through our support team.</li>
                        </ul>
                    </li>

                    <li>
                        <strong>Data Copy</strong>
                        <ul>
                            <li>We do not provide copies of internal logs or stored data.</li>
                        </ul>
                    </li>
                </ul>

                <li>
                    <strong>7. Children’s Privacy</strong>
                    <ul>
                        <li>Fyjix is intended for general use.</li>
                        <li>Users under 18 should use the Service with guardian supervision.</li>
                        <li>We do not knowingly collect personal data specifically targeting children.</li>
                    </ul>
                </li>

                <li>
                    <strong>8. International Users</strong>
                    <ul>
                        <li>If you access the Service from outside India, you consent to processing in India where Fyjix IT Solutions operates.</li>
                    </ul>
                </li>

                <li>
                    <strong>9. Third-Party Services</strong>
                    <ul>
                        <li>Our Service uses:</li>
                        <li>Render for hosting</li>
                        <li>TJSB Bank for payment processing</li>
                        <li>These providers have their own privacy practices. We are not responsible for policies of external services.</li>
                    </ul>
                </li>

                <li>
                    <strong>10. Changes to This Policy</strong>
                    <ul>
                        <li>We may update this Privacy Policy periodically.</li>
                        <li>Significant changes will be posted on our website.</li>
                        <li>Continued use of the Service means you accept the updated terms.</li>
                    </ul>
                </li>

                <li>
                    <strong>11. Contact Us</strong>
                    <ul>
                        <li>If you have questions or requests related to privacy, contact:</li>
                        <li>Email: info@fyjix.com</li>
                        <li>Company: Fyjix IT Solutions</li>
                        <li>Country: India</li>
                    </ul>
                </li>
            </ul>
        </div>
    )
}

export default Privacypolicy